import * as yup from 'yup'

export const passwordResetSchema = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  token: yup.string().required('Reset code is required'),
  password: yup
    .string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
})

export type PasswordResetFormData = yup.InferType<typeof passwordResetSchema>
